import React, { useState } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useEffect } from 'react';
import {
  SafeAreaView,
  Linking,
  ScrollView,
  Text,
  View,
  TextInput,
  Button,
  ActivityIndicator,
  TouchableOpacity,
  StyleSheet,
  KeyboardAvoidingView,
  Platform,
} from 'react-native';
import SupportButton from './components/SupportButton';
//import DiiaRequestSign from './components/DiiaRequestSign'; //todo check if I need it


import axios from 'axios';
// Наприклад, у App.js
import { collection, addDoc } from 'firebase/firestore';
import { db } from './src/firebase';


export default function App() {
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [exchangeRate, setExchangeRate] = useState(null);

  const [amount, setAmount] = useState('');
  const [direction, setDirection] = useState('UAH_TO_USDT'); // направленя обміну

  const [network, setNetwork] = useState('TRC20');
  const [walletAddress, setWalletAddress] = useState('');

  const [cardNumber, setCardNumber] = useState('');
  // http://localhost:3000
  // https://4362-217-66-97-157.ngrok-free.app
  const [ngrokURL, setNgrokURL] = useState('http://localhost:3000')

  const [loadingRequestSign, setLoadingRequestSign] = useState(false);
  const [deeplink, setDeeplink] = useState(null);
  
  const [serverURL, setServerURL] = useState('https://e-crypto-name.onrender.com');

  const handleRequestSign = async () => {
    setLoadingRequestSign(true);
    try {
      // викликаємо бекенд
      const response = await fetch(serverURL+'/api/diia/start-auth', { method: 'POST' });
      const data = await response.json();

      setDeeplink(data.deeplink);
      //window.location.href = data.deeplink; // відкрити Дію 
      // відкриваємо посилання в Дії
      if (data.deeplink) {
        Linking.openURL(data.deeplink);
      }
    } catch (e) {
      console.error("Request sign failed", e);
    } finally {
      setLoadingRequestSign(false);
    }
  };

  const simulateDiiaLogin = async () => {
    setLoading(true);
    try {
      //https://4362-217-66-97-157.ngrok-free.app
      //http://localhost:3000/exchange-token
      const response = await axios.post(ngrokURL + '/exchange-token', {
        code: 'mock_code_from_diia'
      });

      setToken(response.data.token);
      setUser(response.data.user);
      await AsyncStorage.setItem('jwt_token', response.data.token);
      await AsyncStorage.setItem('user', JSON.stringify(response.data.user));


      const rateResponse = await axios.get(ngrokURL + '/usd-rate'); //usd-rate(pb) //rate(mono)
      setExchangeRate(rateResponse.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const calculateResult = () => {
    const numAmount = parseFloat(amount);
    if (!numAmount || !exchangeRate) return '';

    if (direction === 'UAH_TO_USDT') {
      return (numAmount / exchangeRate.sell).toFixed(2);
    } else {
      return (numAmount * exchangeRate.buy).toFixed(2);
    }
  };

  const handleExchange = async () => {
    if (!amount || Number(amount) <= 0) {
      alert('Вкажіть суму');
      return;
    }
    const isCardNumberValid = (card) => /^\d{16}$/.test(card);
    const isWalletValid = (addr) => /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(addr);
    const blockedBins = [
      '414949', // ПриватБанк
      '516874', // Приват
      '516875', // Приват
    ];
    const isBlockedCard = (cardNumber) => {
      const bin = cardNumber.slice(0, 6);
      return blockedBins.includes(bin);
    };

    if (direction === 'UAH_TO_USDT') {
      if (!isWalletValid(walletAddress)) {
        alert('Невірна адреса гаманця');
        return;
      }
    }
    if (direction === 'USDT_TO_UAH') {
      if (!isCardNumberValid(cardNumber)) {
        alert('Некоректний номер картки');
        return;
      }
      if (isBlockedCard(cardNumber)) {
        alert('На жаль, картки цього банку не підтримуються для операцій з криптовалютою');
        return;
      }
    }

    try {
      const docRef = await addDoc(collection(db, 'orders'), {
        direction,
        amount,
        walletAddress,
        cardNumber,
        network,
        fullName: user?.name || 'Невідомо',
        createdAt: new Date().toISOString(),
      });

      console.log('Заявка збережена! ID: ' + docRef.id);
    } catch (e) {
      console.error('Помилка збереження заявки: ', e);
      //('Не вдалося зберегти заявку');
    }

    try {
      //
      const response = await axios.post(ngrokURL + '/exchange', {
        direction,
        amount,
        walletAddress,
        cardNumber,
        network,
        user,
      });

      alert('Заявка на обмін створена!');
    } catch (e) {
      console.error(e);
      alert('Помилка обміну');
    }
  };

  const logout = async () => {
    await AsyncStorage.removeItem('jwt_token');
    await AsyncStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  useEffect(() => {
    const checkToken = async () => {
      const savedToken = await AsyncStorage.getItem('jwt_token');
      const savedUser = await AsyncStorage.getItem('user');

      if (savedToken && savedUser) {
        setToken(savedToken);
        setUser(JSON.parse(savedUser));
      }
    };

    checkToken();
  }, []);

  return (
    <KeyboardAvoidingView
      style={{ flex: 1 }}
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
    >
      <ScrollView contentContainerStyle={styles.container}>
        <SafeAreaView>
          {loading ? (
            <ActivityIndicator size="large" />
          ) : token ? (
            <View style={styles.infoBox}>
              <Button title="Вийти" onPress={logout} />
              <Text style={styles.title}>Вітаємо, {user?.name || 'Користувач'}!</Text>

              <Text style={styles.rate}>Курс купівлі USDT: {exchangeRate?.buy} грн</Text>
              <Text style={styles.rate}>Курс продажу USDT: {exchangeRate?.sell} грн</Text>

              <View style={styles.row}>
                <TouchableOpacity
                  style={[styles.directionButton, direction === 'UAH_TO_USDT' && styles.selectedButton]}
                  onPress={() => setDirection('UAH_TO_USDT')}
                >
                  <Text style={styles.directionText}>UAH → USDT</Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={[styles.directionButton, direction === 'USDT_TO_UAH' && styles.selectedButton]}
                  onPress={() => setDirection('USDT_TO_UAH')}
                >
                  <Text style={styles.directionText}>USDT → UAH</Text>
                </TouchableOpacity>
              </View>

              <TextInput
                style={styles.input}
                keyboardType="numeric"
                placeholder="Введіть сумму"
                value={amount}
                onChangeText={setAmount}
              />

              <Text style={styles.result}>
                {amount ? `Отримаєте: ${calculateResult()} ${direction === 'UAH_TO_USDT' ? 'USDT' : 'UAH'}` : ''}
              </Text>

              {/* Показуємо це поле лише для напрямку UAH_TO_USDT */}
              {direction === 'UAH_TO_USDT' && (
                <>
                  <Text style={styles.label}>Адреса вашого гаманця:</Text>
                  <TextInput
                    style={styles.input}
                    placeholder="Наприклад: TYx...tZp"
                    value={walletAddress}
                    onChangeText={setWalletAddress}
                  />

                  <Text style={styles.label}>Оберіть мережу:</Text>
                  <View style={styles.networkRow}>
                    <TouchableOpacity
                      style={[styles.networkButton, network === 'TRC20' && styles.selectedNetwork]}
                      onPress={() => setNetwork('TRC20')}
                    >
                      <Text style={styles.networkText}>TRC20</Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={[styles.networkButton, network === 'ERC20' && styles.selectedNetwork]}
                      onPress={() => setNetwork('ERC20')}
                    >
                      <Text style={styles.networkText}>ERC20</Text>
                    </TouchableOpacity>
                  </View>
                </>
              )}

              {/* Показуємо це поле лише для напрямку USDT_TO_UAH */}
              {direction === 'USDT_TO_UAH' && (
                <>
                  <Text style={styles.label}>Номер картки для зарахування гривні:</Text>
                  <TextInput
                    style={styles.input}
                    placeholder="Наприклад: 537541XXXXXXXXXX"
                    keyboardType="numeric"
                    maxLength={16}
                    value={cardNumber}
                    onChangeText={setCardNumber}
                  />
                </>
              )}

              <Button title="Обміняти" onPress={handleExchange} />
              {/* mail to button */}
              <SupportButton />

            </View>
          ) : (
            <>
              <Text style={styles.title}>Авторизація через ???</Text>
              <View style={{ flex: 1 }}>
                {/* <DiiaRequestSign /> todo delete*/}
                {loading ? (
                  <ActivityIndicator size="large" />
                ) : (
                  <Button title="Увійти через ???" onPress={handleRequestSign} />
                )}
                {deeplink && (
                  <Text style={{ marginTop: 20, fontSize: 12 }}>
                    Відкрито: {deeplink}
                  </Text>
                )}
              </View>
              {/* mail to button */}
              <SupportButton />
            </>
          )}
        </SafeAreaView>
      </ScrollView>
    </KeyboardAvoidingView>
  );

}

const styles = StyleSheet.create({
  container: { flex: 1, justifyContent: 'center', alignItems: 'center', padding: 20 },
  title: { fontSize: 22, fontWeight: 'bold', marginBottom: 20, textAlign: 'center' },
  infoBox: { alignItems: 'center', width: '100%' },
  rate: { fontSize: 16, marginVertical: 4, textAlign: 'center' },
  row: { flexDirection: 'row', marginVertical: 10, justifyContent: 'center' },
  directionButton: {
    paddingVertical: 8,
    paddingHorizontal: 20,
    marginHorizontal: 5,
    borderWidth: 1,
    borderColor: '#007AFF',
    borderRadius: 5,
  },
  selectedButton: {
    backgroundColor: '#007AFF',
  },
  directionText: {
    // color: '#007AFF',
    fontWeight: 'bold',
  },
  input: {
    borderWidth: 1,
    borderColor: '#ccc',
    width: '80%',
    padding: 10,
    marginVertical: 10,
    borderRadius: 5,
    fontSize: 16,
  },
  result: {
    fontSize: 18,
    marginBottom: 20,
    textAlign: 'center',
  }, networkRow: {
    flexDirection: 'row',
    marginVertical: 10,
    justifyContent: 'center',
  },
  networkButton: {
    paddingVertical: 8,
    paddingHorizontal: 20,
    marginHorizontal: 5,
    borderWidth: 1,
    borderRadius: 10,
    borderColor: '#ccc',
  },
  selectedNetwork: {
    backgroundColor: '#007aff',
    borderColor: '#007aff',
  },
  networkText: {
    color: '#000',
  },

});
